export const MAX_ASSESSMENT_AREA_HA = 1000;
